import React, { useEffect, useState } from 'react';
import {
  intialPageSize,
  spedNoteArchiveSuccess,
  spedNoteUnArchiveSuccess,
} from 'constants';
import {
  onSave,
  emptyFunction,
  useNotification,
  showBackdropLoader,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import {
  LabelValue,
  studentSpedNotesColumns,
  studentSpedNotesListData,
} from './spedNotesTabUtils';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useForm } from 'react-hook-form';
import { GridWrapper } from 'components/Ui/styled';
import { useSelector, useDispatch } from 'react-redux';
import {
  getStudentSpedNote,
  postSpedNoteArchive,
  getStudentSpedNotes,
  postSpedNoteUnArchive,
  getSpedNotesFilterOptions,
} from 'layouts/spedNotes/spedNotes/services/spedNotesApi';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import {
  setIsNewSpedNote,
  setSingleSpedNote,
} from 'layouts/spedNotes/spedNotes/store/spedNotesSlice/spedNoteSlice';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';
import SpedNoteDialog from 'layouts/spedNotes/spedNotes/components/spedComponentTabs/SpedNoteDialog';

function SpedNotesTab() {
  const canSignOffSpedNotes = usePermissionCustomHook('CAN_SIGNOFF_SPED_NOTES');
  const canArchivepedNotes = usePermissionCustomHook('CAN_ARCHIVE_SPED_NOTES');
  const {
    NotificationPopup,
    setOpenNotification,
    handleErrorResponse,
    setNotificationMessage,
  } = useNotification();
  const dispatch = useDispatch();

  const studentData = useSelector((state) => state?.studentDetails) || {};
  const { profile } = studentData || {};
  const { resourceId, firstName, lastName } = profile || {};
  const student = { studentId: resourceId };

  const [spedNotesList, setSpedNotesList] = useState({
    rows: [],
    isLoading: false,
    pageSize: intialPageSize,
  });
  const [spedNoteForm, setSpedNoteForm] = useState({});
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [filterOptions, setfilterOptionss] = useState(null);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [openSingleNewSpedNote, setOpenSingleNewSpedNote] = useState(false);
  const defaultValue = {
    archivedNotes: false,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { control, watch } = useFunction;
  const watchedArchivedNotes = watch('archivedNotes');

  useEffect(() => {
    if (resourceId) {
      fetchAllSpedNotes();
    }
  }, [resourceId, watchedArchivedNotes]);

  const setGridLoading = (isLoading) => {
    setSpedNotesList((prev) => ({
      ...prev,
      isLoading,
    }));
  };

  const fetchAllSpedNotes = async () => {
    try {
      setSpedNotesList((prev) => ({
        ...prev,
        isLoading: true,
      }));

      const spedNotesData = await getStudentSpedNotes(
        '',
        '',
        resourceId,
        watchedArchivedNotes,
      );
      setSpedNotesList((prev) => ({
        ...prev,
        rows: studentSpedNotesListData(spedNotesData),
      }));
      const filterOptions = await getSpedNotesFilterOptions();
      setfilterOptionss(filterOptions);
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    } finally {
      setGridLoading(false);
    }
  };

  const pageSizeChange = pageSizeChangeHandler(setSpedNotesList);
  const studentName = `${firstName || ''} ${lastName || ''} |`;

  const handleEdit = async (params) => {
    const { id } = params?.row;
    try {
      setIsFormLoading(true);
      const getData = await getStudentSpedNote(id);
      setSpedNoteForm(getData);
      setOpenSingleNewSpedNote(true);
      dispatch(setIsNewSpedNote(false));
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleArchive = (params) => {
    const { id } = params?.row;
    onSave(
      spedNoteArchiveSuccess,
      true,
      postSpedNoteArchive,
      emptyFunction,
      id,
      '',
      fetchAllSpedNotes,
      emptyFunction,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setArchiveLoading,
      archiveLoading,
    );
  };

  const handleUnArchive = (params) => {
    const { id } = params?.row;
    onSave(
      spedNoteUnArchiveSuccess,
      true,
      postSpedNoteUnArchive,
      emptyFunction,
      id,
      '',
      fetchAllSpedNotes,
      emptyFunction,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setArchiveLoading,
      archiveLoading,
    );
  };

  const handleNewSpedNote = () => {
    setSpedNoteForm({});
    setOpenSingleNewSpedNote(true);
    dispatch(setIsNewSpedNote(true));
    dispatch(setSingleSpedNote(true));
  };

  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <MDBox pt={2} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={8}>
          <MDBox display="flex" gap={1}>
            <LabelValue label="Name" value={studentName} />
            <LabelValue label="Student ID" value={resourceId} />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={2}>
          <MDBox display="flex" justifyContent="flex-end">
            <FormInputSwitch
              control={control}
              name="archivedNotes"
              label="Archived Notes"
              checked={defaultValue?.archivedNotes}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={2}>
          <MDBox display="flex" justifyContent="flex-end">
            <Button onClick={handleNewSpedNote} variant="text">
              New SPED note
            </Button>
          </MDBox>
        </Grid>
      </Grid>

      <MDBox pt={2} />
      <GridWrapper container spacing={2}>
        <DeltaDataGrid
          listData={spedNotesList}
          setListData={pageSizeChange}
          columns={studentSpedNotesColumns(
            handleEdit,
            handleArchive,
            handleUnArchive,
            canArchivepedNotes,
            canSignOffSpedNotes,
          )}
        />
      </GridWrapper>
      <SpedNoteDialog
        selectedStudent={student}
        spedNoteForm={spedNoteForm}
        open={openSingleNewSpedNote}
        filterOptions={filterOptions}
        setSpedNoteForm={setSpedNoteForm}
        fetchSpedNotes={fetchAllSpedNotes}
        setOpen={setOpenSingleNewSpedNote}
        isSingleStudent={openSingleNewSpedNote}
      />
      <NotificationPopup />
    </>
  );
}

export default SpedNotesTab;
